import { Button } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./VerifyCode.module.css";
import logo from "../../../assets/images/logo.png";
import {
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { IoChevronBackOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import { TbLockCheck } from "react-icons/tb";
import { PiSealCheck } from "react-icons/pi";
import { roles } from "../../../config/roles";
import { getUser, isLogin } from "../../../Store/Actions/AuthAction";
import Storage from "../../../utills/AsyncStorage";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { validateForm } from "../../../utills/Validators";

function VerifyCode() {
  const location = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);

  console.log("Location", location);

  const formState = [{ message: "Please Enter Otp", value: otp }];
  const onPressSignUpVerify = (e) => {
    e.preventDefault();
    let userdata = {
      email: location?.state?.email,
      role: location?.state?.role.toLowerCase(),
      code: otp,
    };
    const validation = validateForm(formState);
    if (!validation.isValid) {
      dispatch(
        showAlert({
          type: "Error",
          message: validation.message,
        }),
      );
    } else {
      dispatch(AuthMiddleware.signUpVerifyCode(userdata))
        .then(() => {
          setIsSuccessFulModal(true);
        })
        .catch(() => {});
    }
  };

  const onPressForgotVerify = (e) => {
    e.preventDefault();
    let userdata = {
      email: location?.state?.email,
      role: location?.state?.role.toLowerCase(),
      code: otp,
    };
    const validation = validateForm(formState);
    if (!validation.isValid) {
      dispatch(
        showAlert({
          type: "Error",
          message: validation.message,
        }),
      );
    } else {
      dispatch(AuthMiddleware.forgotVerifyCode(userdata))
        .then(() => {
          navigate("/createPassword", {
            state: {
              email: location?.state?.email,
              role: location?.state?.role,
              code: otp,
            },
          });
        })
        .catch(() => {});
    }
  };

  const onPressLoginVerify = (e) => {
    e.preventDefault();
    let userdata = {
      user_id: location?.state?.id,
      type: location?.state?.role.toLowerCase(),
      code: otp,
    };
    const validation = validateForm(formState);
    if (!validation.isValid) {
      dispatch(
        showAlert({
          type: "Error",
          message: validation.message,
        }),
      );
    } else {
      dispatch(AuthMiddleware.verifyCodeOTP(userdata));
    }
  };

  // const naviagteScreens = () => {
  //   setIsSuccessFulModal(false)
  //   if (location?.state?.role == roles.user) {
  //     navigate("/moduleRegistration", { state: "userModule" });
  //   } else {
  //     navigate("/accountSetup");
  //   }
  // };

  const onResendCode = () => {
    let userdata = {
      role: location.state.role.toLowerCase(),
      email: location.state.email,
    };

    dispatch(AuthMiddleware.forgetPassword(userdata));
  };

  const submitFunction = (e) => {
    if (location?.state?.screen === "signup") {
      onPressSignUpVerify(e);
    } else if (location?.state?.screen === "login") {
      onPressLoginVerify(e);
    } else if (location?.state?.screen === "forgot") {
      onPressForgotVerify(e);
    }
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          <form onSubmit={(e) => submitFunction(e)}>
            <div className={styles.backDiv} onClick={() => navigate("/")}>
              <IoChevronBackOutline />
              <TextComponent text={"Back to login"} />
            </div>
            <div className={styles.textDiv}>
              <TextComponent
                className={styles.welcomeHeading}
                text={"Verify Code"}
              />
              <TextComponent
                className={styles.welcomeText}
                text={"Please enter your verification code from email address"}
              />
            </div>
            <div
              className={styles.enterCodeDiv}
              //   style={{textDecorationColor}}
            >
              <TextComponent
                style={{ fontSize: "var(--mobile-heading)", fontWeight: "600" }}
                text={"Enter Code"}
              />
              <div className={styles.resendCodeDiv}>
                <TextComponent text={"Didn't get code?"} />
                <TextComponent
                  onClick={
                    // location?.state?.screen == "signup" ? null :
                    onResendCode
                  }
                  style={{
                    marginLeft: "5px",
                    textDecoration: "undeline",
                    color: "var(--secondary-color)",
                    textDecorationLine: "underline",
                    textDecorationColor: "var(--secondary-color)",
                    cursor: "pointer",
                  }}
                  text={"Resend"}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <OTPInput
                containerStyle={styles.otpInputDiv}
                inputStyle={{
                  width: "100%",
                  height: "50px",
                  border: "1px solid var(--secondary-color)",
                  borderRadius: "8px",
                  fontSize: "25px",
                  color: "var(--secondary-color)",
                }}
                // inputStyle={styles.otpInput}
                value={otp}
                onChange={setOtp}
                numInputs={5}
                renderSeparator={<span>&emsp;</span>}
                renderInput={(props) => <input type="number" {...props} />}
              />
            </div>
            <div className={styles.btn}>
              <SubmitButton
                title={"Verify"}
                // onClick={
                //   location?.state?.screen == "signup"
                //     ? onPressSignUpVerify
                //     : location?.state?.screen == "login"
                //     ? onPressLoginVerify
                //     : location?.state?.screen == "forgot"
                //     ? onPressForgotVerify
                //     : null
                // }
                type="submit"
              />
            </div>
          </form>
        </div>
      </div>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Email Verified successfully"}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"Setup  your account"}
        onBtnPress={() => setIsSuccessFulModal(false)}
        // onBtnPress={onPressVerify}
      ></Modal>
    </div>
  );
}

export default VerifyCode;
